import { NOTIFICATION_TYPES } from '../constants/index';
import { writable } from 'svelte/store';

const NOTIFICATION_TIMEOUT = 3000;

export const notifications = (() => {
    const alerts = writable([]);

    const setAlert =
        type =>
        ({ title = 'Error', description = null, icon = null, autoClose = false, close = null }) =>
            alerts.update($alerts => {
                const index = $alerts.length + 1;

                // close alert automatically
                if (autoClose) {
                    const timer = setTimeout(() => {
                        notifications.close(index);
                        clearTimeout(timer);
                    }, NOTIFICATION_TIMEOUT);
                }

                const _close = () => closeAlert(index);

                return [...$alerts, { type, title, description, icon, id: index, close: close || _close }];
            });

    const closeAlert = index => {
        alerts.update($alerts => {
            return $alerts.filter(alert => alert.id !== index);
        });
    };

    const closeAllAlerts = () => alerts.set([]);

    return {
        subscribe: alerts.subscribe,
        showInfo: setAlert(NOTIFICATION_TYPES.INFO),
        showError: setAlert(NOTIFICATION_TYPES.DANGER),
        showSuccess: setAlert(NOTIFICATION_TYPES.SUCCESS),
        showWarning: setAlert(NOTIFICATION_TYPES.WARNING),
        close: closeAlert,
        closeAll: closeAllAlerts
    };
})();
